module.exports = __webpack_public_path__ + "img/motorcycle.b39d9cdb.png";